import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./context/UserContext";
import "swiper/css";
import "swiper/css/pagination";

const root = ReactDOM.createRoot(document.getElementById("root"));
// ساخت cache برای RTL
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [rtlPlugin],
});

// ساخت تم با راست‌چین بودن
const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "Vazirmatn, Roboto, sans-serif",
  },
});

document.body.dir = "rtl";
root.render(
  <React.StrictMode>
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <UserProvider>
          <App />
        </UserProvider>
      </ThemeProvider>
    </CacheProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
